/**
 * @generated SignedSource<<f70cb19064aace212d3396de9f42cec6>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 * Schema: cc
 *
 * @see https://go/typsy
 **/

export type Exact<
  T extends {
    [key: string]: unknown;
  },
> = {
  [K in keyof T]: T[K];
};
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: {
    input: string;
    output: string;
  };
  String: {
    input: string;
    output: string;
  };
  Boolean: {
    input: boolean;
    output: boolean;
  };
  Int: {
    input: number;
    output: number;
  };
  Float: {
    input: number;
    output: number;
  };
  DateTime: {
    input: Date;
    output: Date;
  };
  /** Long type */
  Long: {
    input: number;
    output: number;
  };
  /** High level representation of a Number could be a float or an integer */
  Number: {
    input: number;
    output: number;
  };
}
export enum AccessType {
  EDIT = "EDIT",
  VIEW = "VIEW",
}
export interface GrantContentAccessInput {
  accessType: AccessType;
  accountIdOrUsername: Scalars["String"]["input"];
  contentId: Scalars["String"]["input"];
}
export type GrantAccessDialogGrantContentAccessMutation_grantContentAccess_GrantContentAccessPayload =
  {
    __typename?: "GrantContentAccessPayload";
    success: boolean;
  };
export type GrantAccessDialogGrantContentAccessMutation_Mutation = {
  __typename?: "Mutation";
  grantContentAccess: GrantAccessDialogGrantContentAccessMutation_grantContentAccess_GrantContentAccessPayload;
};
export type GrantAccessDialogGrantContentAccessMutationVariables = Exact<{
  grantContentAccessInput: GrantContentAccessInput;
}>;
export type GrantAccessDialogGrantContentAccessMutation =
  GrantAccessDialogGrantContentAccessMutation_Mutation;
